function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import { AelfIcon } from "../../icon/AelfIcon";
var AelfSVGComponent = function AelfSVGComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19.983 15.286a5.785 5.785 0 1 0 0-11.57 5.785 5.785 0 0 0 0 11.57Zm-11.734 0a4.383 4.383 0 1 0 0-8.766 4.383 4.383 0 0 0 0 8.766ZM7.36 27.232c0 .033 0 .066.002.099H2.5a1 1 0 0 1-1-1v-4.886c0-.591.327-1.133.85-1.41A19.262 19.262 0 0 1 9.46 17.9a22.04 22.04 0 0 0-.636.36 2.969 2.969 0 0 0-1.464 2.56v6.413Zm2.104-6.001c0-.563.298-1.083.782-1.368a19.2 19.2 0 0 1 19.47 0c.485.285.783.805.783 1.368v6.052a1 1 0 0 1-1 1H10.465a1 1 0 0 1-1-1V21.23Z"
  }));
};
var componentName = 'GroupFilled';
export var GroupFilled = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(AelfIcon, _extends({
    component: AelfSVGComponent,
    ref: ref
  }, props));
});
GroupFilled.displayName = componentName;